const DAYS = [
  ['monday', 'Monday'],
  ['tuesday', 'Tuesday'],
  ['wednesday', 'Wednesday'],
  ['thursday', 'Thursday'],
  ['friday', 'Friday'],
  ['saturday', 'Saturday'],
  ['sunday', 'Sunday'],
];

const DEFAULT_DAY = { open: '09:00', close: '18:00', closed: false };

// Edits a weekly hours object: { monday: { open, close, closed }, ... }.
// Used for both location working hours and per-staff schedules.
const WeeklyHoursEditor = ({ value, onChange, disabled = false }) => {
  const hours = value || {};

  const setDay = (day, patch) => {
    const current = hours[day] || DEFAULT_DAY;
    onChange({ ...hours, [day]: { ...current, ...patch } });
  };

  return (
    <div className="divide-y divide-ink-900/10 overflow-hidden bg-white ring-1 ring-ink-900/10">
      {DAYS.map(([day, label]) => {
        const entry = hours[day] || DEFAULT_DAY;
        return (
          <div
            key={day}
            className="flex flex-col gap-2.5 px-3 py-3 sm:flex-row sm:items-center sm:justify-between sm:gap-3 sm:px-4"
          >
            <label className="flex min-w-0 items-center gap-3">
              <input
                type="checkbox"
                checked={!entry.closed}
                disabled={disabled}
                onChange={(e) => setDay(day, { closed: !e.target.checked })}
                className="h-4 w-4 flex-none accent-saffron-500"
              />
              <span className="text-sm font-medium text-ink-900 sm:w-24">{label}</span>
            </label>

            {entry.closed ? (
              <span className="pl-7 text-sm text-ink-600/60 sm:pl-0">Closed</span>
            ) : (
              <div className="grid grid-cols-[1fr_auto_1fr] items-center gap-2 pl-7 sm:flex sm:pl-0">
                <input
                  type="time"
                  value={entry.open}
                  disabled={disabled}
                  onChange={(e) => setDay(day, { open: e.target.value })}
                  className="min-w-0 w-full bg-sand-100 px-2 py-2 text-sm text-ink-900 ring-1 ring-inset ring-ink-900/15 focus:outline-none focus:ring-2 focus:ring-saffron-500 sm:w-auto sm:px-3"
                />
                <span className="text-center text-sm text-ink-600/60">to</span>
                <input
                  type="time"
                  value={entry.close}
                  disabled={disabled}
                  onChange={(e) => setDay(day, { close: e.target.value })}
                  className="min-w-0 w-full bg-sand-100 px-2 py-2 text-sm text-ink-900 ring-1 ring-inset ring-ink-900/15 focus:outline-none focus:ring-2 focus:ring-saffron-500 sm:w-auto sm:px-3"
                />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default WeeklyHoursEditor;
